import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const translationLoaders = {
  en: () => import('./en').then(({ eng }) => eng),
  es: () => import('./es').then(({ esp }) => esp),
  pt: () => import('./pt').then(({ pt }) => pt),
};

const lazyTranslations = {
  type: 'backend' as const,
  read(language, namespace, callback) {
    const load = translationLoaders[language];
    if (!load) {
      callback(null, {});
      return;
    }
    load().then((translation) => callback(null, translation), (error) => callback(error, null));
  },
};

export const i18nReady = i18n
  .use(lazyTranslations)
  .use(LanguageDetector)
  .use(initReactI18next).init({
    fallbackLng: 'pt',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
  });

export default i18n;
